import cn from 'classnames';

import Text from 'components/common/Text';
import Tag from 'components/icons/Tag';
import { HOME_CHEF } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const DiscountTag = ({
  discountText,
  spanClassNames = '',
  brandStylesOverrides = '',
  textClassName = '',
  flex = true,
}) => {
  const isHomeChef = useBrand(HOME_CHEF);

  return (
    <Text
      brandStylesOverrides={brandStylesOverrides}
      htmlElement="span"
      className={cn(spanClassNames, 'mx-2 h-6 items-center rounded px-2', {
        'bg-green-50': isHomeChef,
        'bg-tempo-blue-50': !isHomeChef,
        flex: flex,
      })}
    >
      <Tag className="text-primary pr-1.5" />
      <Text
        htmlElement="span"
        className={`${textClassName} text-primary inline-block`}
        brandStylesOverrides="h7"
      >
        {discountText}
      </Text>
    </Text>
  );
};

DiscountTag.propTypes = {
  discountText: PropTypes.string,
  spanClassNames: PropTypes.string,
  textClassName: PropTypes.string,
  brandStylesOverrides: PropTypes.string,
  flex: PropTypes.bool,
};

export default DiscountTag;
